@if (authService.isLoggedIn()) {
  <div class="app-layout">
    <app-admin-sidebar />
    <main class="app-content">
      <router-outlet />
    </main>
  </div>
} @else {
  <router-outlet />
}
